(function () {
  var loadedScripts = {};

  function loadScript(key, src) {
    if (window.__swOk === false) return Promise.reject(new Error('x'));
    if (loadedScripts[key]) return loadedScripts[key];

    loadedScripts[key] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-runtime-lib="' + key + '"]');
      if (existing) {
        if (existing.getAttribute('data-loaded') === 'true') {
          resolve();
          return;
        }

        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.setAttribute('data-runtime-lib', key);

      script.addEventListener(
        'load',
        function () {
          script.setAttribute('data-loaded', 'true');
          resolve();
        },
        { once: true }
      );
      script.addEventListener('error', reject, { once: true });

      document.head.appendChild(script);
    });

    return loadedScripts[key];
  }

  function hasAlpineMarkup(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = scope.querySelectorAll('*');
    var i;
    var j;

    for (i = 0; i < elements.length; i++) {
      var attrs = elements[i].attributes;
      for (j = 0; j < attrs.length; j++) {
        var name = attrs[j].name;
        if (name === 'x-data' || name.indexOf('x-') === 0 || name.charAt(0) === '@') {
          return true;
        }
      }
    }

    return false;
  }

  function maybeLoadAlpine(root) {
    if (document.documentElement.hasAttribute('data-alpine-runtime-loading')) return;
    if (window.Alpine) return;
    if (!hasAlpineMarkup(root)) return;

    document.documentElement.setAttribute('data-alpine-runtime-loading', 'true');
    loadScript(
      'alpine-collapse',
      'https://cdn.jsdelivr.net/npm/@alpinejs/collapse@3.x.x/dist/cdn.min.js'
    )
      .then(function () {
        return loadScript('alpine-core', 'https://cdn.jsdelivr.net/npm/alpinejs@3.x.x/dist/cdn.min.js');
      })
      .catch(function () {})
      .finally(function () {
        document.documentElement.setAttribute('data-alpine-runtime-loaded', 'true');
      });
  }

  function maybeLoadIconify(root) {
    if (document.documentElement.hasAttribute('data-iconify-runtime-loading')) return;
    if (window.customElements && customElements.get('iconify-icon')) return;

    var scope = root && root.querySelector ? root : document;
    var hasIconifyRoot = !!(scope && scope.matches && scope.matches('iconify-icon'));
    var hasIconifyDescendant = !!(scope && scope.querySelector && scope.querySelector('iconify-icon'));
    if (!hasIconifyRoot && !hasIconifyDescendant) return;

    document.documentElement.setAttribute('data-iconify-runtime-loading', 'true');
    loadScript('iconify', 'https://cdn.jsdelivr.net/npm/iconify-icon@2/dist/iconify-icon.min.js')
      .catch(function () {})
      .finally(function () {
        document.documentElement.setAttribute('data-iconify-runtime-loaded', 'true');
      });
  }

  function boot(root) {
    maybeLoadAlpine(root);
    maybeLoadIconify(root);
  }

  function init() {
    boot(document);

    var observer = new MutationObserver(function (mutations) {
      var i;
      var j;

      for (i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node || node.nodeType !== 1) continue;
          boot(node);
        }
      }

      if (window.Alpine && window.customElements && customElements.get('iconify-icon')) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
